import { Button, ButtonGroup, ModalBody, ModalFooter, useToast } from "@chakra-ui/react";
import { Alert, Form, Icon, Modal } from "components";
import { API } from "config";
import { useState } from "react";

export default function Fiscal({ data, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ file, setFile ] = useState()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!window.confirm('Tem certeza que deseja anexar a nota?')) return
        setLoading(true)
        
        const form = new FormData()
        form.append('file', file)
        form.append('_method', 'put')

        try{
            await API.post(`/withdraws/${data?.id}/fiscal`, form, { headers: { "Content-Type": "multipart/form-data" } })
            toast({ title: "Nota fiscal anexada", status: 'success' })
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: "Não foi possível anexar a nota. Tente novamente.", description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <Modal title="Anexar nota fiscal" loading={loading} {...props}>
        <ModalBody>
            <Alert>Ao anexar a nota fiscal, você estará sobrescrevendo o arquivo anterior, caso exista.</Alert>

            <Form.Form mt={4}>
                <Form.File 
                    required
                    label="Arquivo da nota fiscal"
                    onChange={setFile}
                    isDisabled={loading}
                />
            </Form.Form>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Anexar nota" leftIcon={<Icon name="attachment" />} colorScheme="orange" isLoading={loading} isDisabled={!file} onClick={handleSubmit} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}